import type { Ctx } from '@milkdown/kit/ctx';
import type { useNodeViewFactory } from '@prosemirror-adapter/react';
import { prosePluginsCtx } from '@milkdown/kit/core';
import { Plugin } from '@milkdown/kit/prose/state';

import { CONTENT_VARIANT_NODE_NAME, VARIABLE_CONTENT_NODE_NAME } from '../constants';
import { ContentVariantNodeView } from './ContentVariantNodeView';
import { VariableContentNodeView } from './VariableContentNodeView';

function isControlEvent(event: Event): boolean {
  const target = event.target;
  if (!(target instanceof Element)) {
    return false;
  }

  return Boolean(target.closest('[data-variant-controls], [data-variable-content-controls]'));
}

export function configureVariableContentNodeViews(ctx: Ctx, nodeViewFactory: ReturnType<typeof useNodeViewFactory>) {
  ctx.update(prosePluginsCtx, (plugins) => [
    ...plugins,
    new Plugin({
      props: {
        nodeViews: {
          [VARIABLE_CONTENT_NODE_NAME]: nodeViewFactory({
            component: VariableContentNodeView,
            stopEvent: isControlEvent,
          }),
          [CONTENT_VARIANT_NODE_NAME]: nodeViewFactory({
            component: ContentVariantNodeView,
            stopEvent: isControlEvent,
          }),
        },
      },
    }),
  ]);
}
